import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  Link,
  ButtonGroup,
  Button,
  useTheme,
} from "@mui/material";

import {
  BCPCertificate,
  BCPSquarePlus,
  BCPCalendarDay,
  BCPTrophy,
  BCPPen,
  BCPArrowLeft,
  BCPCircleCheck,
} from "../../../components/icons/bcp/BCPIcons";

import ListResponsive from "../../../components/other/ListResponsive";
import { handlePagingAll } from "../../../components/api/APIUtilities";

import moment from "moment";
import { getEnvironmentVariable } from "../../../global/environmentVariables";
import ExternalButtonBase from "../../../components/utilities/ExternalButtonBase";

export default function OrganizationCircuits(props) {
  const { organization, authContext } = props;

  const [subLoading, setSubLoading] = useState(true);
  const [activeLeagues, setActiveLeagues] = useState(null);
  const [inactiveLeagues, setInactiveLeagues] = useState(null);

  const [leagueType, setLeagueType] = useState("active");

  const theme = useTheme();

  useEffect(() => {
    const check = async () => {
      const queryParams = {
        gameStoreId: organization?.id,
        "expand[]": ["gameSystem"],
      };
      if (getEnvironmentVariable("SINGLE_GAME_SYSTEM")) {
        queryParams.gameSystemId = getEnvironmentVariable("SINGLE_GAME_SYSTEM");
      } else if (getEnvironmentVariable("SINGLE_GAME_TYPE")) {
        queryParams.gameType = getEnvironmentVariable("SINGLE_GAME_TYPE");
      } else if (getEnvironmentVariable("SINGLE_GAME_MANUFACTURER")) {
        queryParams.gameSystemManufacturer = getEnvironmentVariable(
          "SINGLE_GAME_MANUFACTURER"
        );
      }
      const apiGetData = await handlePagingAll("/leagues", {
        ...queryParams,
        active: true,
      });
      const inactiveLeagueData = await handlePagingAll("/leagues", {
        ...queryParams,
        active: false,
      });

      setActiveLeagues(apiGetData);
      setInactiveLeagues(inactiveLeagueData);
      setSubLoading(false);
    };
    check();
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container sx={{ gap: 2, p: 2 }}>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Link
              href="/organize/game-stores"
              color="link.main"
              sx={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <BCPArrowLeft
                sx={{ "padding-right": "1rem", "padding-bottom": "2px" }}
              />{" "}
              Back to My Organizations
            </Link>
          </Grid>

          <Grid item xs={12} md={9}>
            <Typography
              variant="h2"
              component="h3"
              fontWeight="700"
              gutterBottom
            >
              Circuits
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <ListResponsive
              originalList={
                subLoading
                  ? null
                  : leagueType === "inactive"
                    ? inactiveLeagues
                    : activeLeagues
              }
              doSearch
              actionButton={
                authContext?.authState?.identity?.isAdmin === true ||
                organization?.myStoreUser?.createLeagues ||
                organization?.ownerId ===
                  authContext?.authState?.identity?.userId
                  ? [
                      {
                        props: {
                          variant: "contained",
                          color: "primary",
                          href: `/organize/circuit?organizationId=${organization?.id}`,
                          startIcon: <BCPSquarePlus />,
                        },
                        label: "Add Circuit",
                      },
                    ]
                  : null
              }
              searchProps={{
                label: "Search Circuits",
                performSearch: (originalList, searchText) => {
                  if (!searchText || searchText === "") {
                    return originalList;
                  } else {
                    var filteredList = originalList.filter(function (el) {
                      if (el?.name?.toLowerCase().includes(searchText))
                        return true;
                      if (
                        el?.gameSystem?.name?.toLowerCase().includes(searchText)
                      )
                        return true;

                      return false;
                    });
                    return filteredList;
                  }
                },
              }}
              rowProps={{
                mapFunction: (row, index) => (
                  <Grid item xs={12}>
                    <Card key={index} sx={{ mt: 2 }}>
                      <CardContent>
                        <Box sx={{ width: "100%" }}>
                          <Typography variant="h3" gutterBottom>
                            {row?.name}{" "}
                            {row?.active ? (
                              ""
                            ) : (
                              <>
                                {" - "}
                                <span
                                  style={{ color: theme?.palette?.error.main }}
                                >
                                  {`(Inactive)`}
                                </span>
                              </>
                            )}
                          </Typography>
                          <Typography variant="h4" gutterBottom>
                            {`${row.gameSystem?.name}${
                              getEnvironmentVariable("SUPPORTS_HOBBY_TRACK") ===
                                "true" && row.hobby
                                ? " - Hobby Track"
                                : ""
                            }`}
                          </Typography>
                          <Typography variant="caption" gutterBottom>{`${
                            row?.startDate
                              ? moment(row.startDate).format("Do MMM YYYY")
                              : ""
                          }${
                            row?.endDate
                              ? ` - ${moment(row.endDate).format(
                                  "Do MMM YYYY"
                                )}`
                              : ""
                          }`}</Typography>
                        </Box>
                        <Grid container spacing={1}>
                          {!getEnvironmentVariable("HIDE_RANKINGS") && (
                            <Grid item xs={12} sm={6} lg={3} sx={{ p: 2 }}>
                              <ExternalButtonBase
                                sx={{
                                  width: "100%",
                                  display: "block",
                                  borderColor: "divider",

                                  p: 1,
                                  textAlign: "center",
                                  border: "1px solid rgba(0, 0, 0, 0.12)",
                                  borderRadius: 1,
                                  boxShadow: 1,
                                  backgroundColor: "background.secondary",

                                  "&:hover": {
                                    backgroundColor: "rgb(46 55 77 / 24%);",
                                  },
                                }}
                                href={`/rankings/${row.id}?embed=true`}
                                target="_blank"
                              >
                                <Typography gutterBottom>
                                  <BCPTrophy
                                    style={{ "font-size": 50, width: 50 }}
                                  />
                                </Typography>
                                <Typography variant="h3" gutterBottom>
                                  Rankings
                                </Typography>
                              </ExternalButtonBase>
                            </Grid>
                          )}

                          <Grid item xs={12} sm={6} lg={3} sx={{ p: 2 }}>
                            <ExternalButtonBase
                              sx={{
                                width: "100%",
                                display: "block",
                                borderColor: "divider",

                                p: 1,
                                textAlign: "center",
                                border: "1px solid rgba(0, 0, 0, 0.12)",
                                borderRadius: 1,
                                boxShadow: 1,
                                backgroundColor: "background.secondary",

                                "&:hover": {
                                  backgroundColor: "rgb(46 55 77 / 24%);",
                                },
                              }}
                              href={`/circuit/${row.id}/calendar?embed=true`}
                              target="_blank"
                            >
                              <Typography gutterBottom>
                                <BCPCalendarDay
                                  style={{ "font-size": 50, width: 50 }}
                                />
                              </Typography>
                              <Typography variant="h3" gutterBottom>
                                Calendar
                              </Typography>
                            </ExternalButtonBase>
                          </Grid>
                          <Grid item xs={12} sm={6} lg={3} sx={{ p: 2 }}>
                            <ExternalButtonBase
                              sx={{
                                width: "100%",
                                display: "block",
                                borderColor: "divider",

                                p: 1,
                                textAlign: "center",
                                border: "1px solid rgba(0, 0, 0, 0.12)",
                                borderRadius: 1,
                                boxShadow: 1,
                                backgroundColor: "background.secondary",

                                "&:hover": {
                                  backgroundColor: "rgb(46 55 77 / 24%);",
                                },
                              }}
                              href={`/organize/circuit/${row.id}?active_tab=details`}
                              disabled={
                                authContext?.authState?.identity?.isAdmin !==
                                  true &&
                                !organization?.myStoreUser?.createLeagues &&
                                organization?.ownerId !==
                                  authContext?.authState?.identity?.userId
                              }
                            >
                              <Typography gutterBottom>
                                <BCPPen
                                  style={{ "font-size": 50, width: 50 }}
                                />
                              </Typography>
                              <Typography variant="h3" gutterBottom>
                                Edit
                              </Typography>
                            </ExternalButtonBase>
                          </Grid>

                          <Grid item xs={12} sm={6} lg={3} sx={{ p: 2 }}>
                            <ExternalButtonBase
                              sx={{
                                width: "100%",
                                display: "block",
                                borderColor: "divider",

                                p: 1,
                                textAlign: "center",
                                border: "1px solid rgba(0, 0, 0, 0.12)",
                                borderRadius: 1,
                                boxShadow: 1,
                                backgroundColor: "background.secondary",

                                "&:hover": {
                                  backgroundColor: "rgb(46 55 77 / 24%);",
                                },
                              }}
                              href={`/organize/circuit/${row.id}?active_tab=tokens`}
                              disabled={
                                authContext?.authState?.identity?.isAdmin !==
                                  true &&
                                !organization?.myStoreUser?.approveTokens &&
                                organization?.ownerId !==
                                  authContext?.authState?.identity?.userId
                              }
                            >
                              <Typography gutterBottom>
                                <BCPCertificate
                                  style={{ "font-size": 50, width: 50 }}
                                />
                              </Typography>
                              <Typography variant="h3" gutterBottom>
                                Tokens
                              </Typography>
                            </ExternalButtonBase>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                ),
              }}
              customComponent={
                <ButtonGroup fullWidth sx={{ mb: 1 }}>
                  <Button
                    fullWidth
                    onClick={() => setLeagueType("active")}
                    variant={leagueType === "active" ? "contained" : "outlined"}
                    startIcon={
                      leagueType === "active" ? <BCPCircleCheck /> : null
                    }
                  >
                    Active
                  </Button>
                  <Button
                    fullWidth
                    onClick={() => setLeagueType("inactive")}
                    variant={
                      leagueType === "inactive" ? "contained" : "outlined"
                    }
                    startIcon={
                      leagueType === "inactive" ? <BCPCircleCheck /> : null
                    }
                  >
                    Inactive
                  </Button>
                </ButtonGroup>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
